






















































import {Component, Vue} from 'vue-property-decorator';
import {getUrlReportViewer} from '@/modules/neodash/model/constants/reportViewer';
import {i18nMixin} from '@/modules/neodash/mixins';
import {GET_PERIOD} from '@/modules/neodash/store/modules/reports/types';
import {Getter} from 'vuex-class';
import {CONFIG} from '@/config';
import {IKeyValue, IKeyValues} from '@/interfaces/key-value-interface';
import {MitsubishStoresLocationAnnualPerformance} from '@/modules/neodash/model/types/interfaces/MitsubishStoresLocation';
import {Period, PeriodFormValue} from '@/modules/neodash/model/types/interfaces/Period';
import {NameValueGeneric, NameValues, NameValuesGeneric, OptionalNameValue} from '@/modules/neodash/model/types/interfaces/NameValue';
import {FilterService} from '@/modules/neodash/services/filterService';
import {ReportsReportViewerEnum} from '@/modules/neodash/model/types/enums/reportsReportViewerEnum';
import {ReportEnum} from '@/modules/neodash/model/types/enums/reportEnum';
import ReportContainer from '@/modules/neodash/components/report-container/report-container.vue';
import FilterContainer from '@/modules/neodash/components/filter-container/filter-container.vue';
import FormPeriod from '@/modules/neodash/components/filter-form/period-form/period-form.vue';
import ReportViewerContainer from '@/modules/neodash/components/report-viewer-container/report-viewer-container.vue';
import ReportPlaceHolder from '@/modules/neodash/components/report-placeholder/report.placeholder.vue';
import ReportAppBar from '@/modules/neodash/components/report-app-bar/report-app-bar.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import FilterMultiSelect from '@/modules/neodash/components/filter-form/filter-multi-select/filterMultiSelect.vue';
import FilterDropDown from '@/modules/neodash/components/filter-form/filter-drop-down/filterDropDown.vue';
import {ServiceHelper} from '@/utils/service.helper';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';

import {AxiosError, AxiosResponse} from 'axios';
import {httpService} from '@/services/http.service';
import data from '*.json';

type StoresFilter = (obj: MitsubishStoresLocationAnnualPerformance) => boolean;
  type FilterNameValue = (lst: NameValues) => StoresFilter;
  type FilterMultipleNameValue = (lst1: NameValues, lst2: NameValues) => StoresFilter;

  enum reportTypeEnum {
    report = 1,
    analytics = 2
  }

  enum printTypeEnum {
    national = 1,
    regions = 2,
    areas = 3,
    groups = 4,
    dealers = 5
  }

  enum localeType {
    Operational = 'Operacional',
    OperationalMixed = 'Operacional Mista',
    Acting = 'Atuação',
    ActingChanged = 'Atuação Modificada'
  }

  enum salesType {
    Retail = 'Varejo',
    RetailExceptBigFleet = 'Varejo + VD (Exceto Big Fleet)',
    Total = 'Total'
  }

  interface labelFilter extends IKeyValue {
    type: printTypeEnum;
  }

  @Component({
    name: 'AnnualSales',
    components: {
      PageLoader,
      ReportPlaceHolder,
      ReportAppBar,
      FilterDropDown,
      FilterMultiSelect, ReportViewerContainer, FormPeriod, FilterContainer, ReportContainer
    }
  })
  export default class AnnualSalesPerformance extends Vue {
    public readonly translate = i18nMixin.methods.i18n;
    public readonly typeReport = printTypeEnum;

    public readonly keyLabelReportType: string = 'Common.ReportType';
    public readonly keyLabelPrintType: string = 'Common.PrintType';
    public readonly keyLabelNational: string = 'Filters.LocationType.National';
    public readonly keyLabelRegional: string = 'Filters.LocationType.Regional';
    public readonly keyLabelArea: string = 'Common.Areas';
    public readonly keyLabelGroup: string = 'Common.Group';
    public readonly keyLabelDealers: string = 'Common.Stores';
    public readonly keyLabelLocaleType: string = 'Common.LocaleType';
    public readonly keyLabelSalesType: string = 'Common.SaleType';

    public readonly keyReportType = 'Common.Report';
    public readonly keyAnalyticsType = 'Common.Analytics';
    public readonly keyLocaleTypeOperational = 'Filters.LocationType.OperationalArea';
    public readonly keyLocaleTypeOperationalMixed = 'Filters.LocationType.OperationalAreaMixed';
    public readonly keyLocaleTypeActing = 'Filters.LocationType.ActingArea';
    public readonly keyLocaleTypeActingChanged = 'Filters.LocationType.ActingChangedArea';

    public readonly reportTypes: NameValues = [
      {name: this.translate(this.keyReportType), value: reportTypeEnum.report},
      {name: this.translate(this.keyAnalyticsType), value: reportTypeEnum.analytics},
    ];

    public readonly types: NameValues = [
      {name: this.translate(this.keyLabelNational), value: printTypeEnum.national},
      {name: this.translate(this.keyLabelRegional), value: printTypeEnum.regions},
      {name: this.translate(this.keyLabelArea), value: printTypeEnum.areas},
      {name: this.translate(this.keyLabelGroup), value: printTypeEnum.groups},
      {name: this.translate(this.keyLabelDealers), value: printTypeEnum.dealers},
    ];

    public readonly localeType: NameValuesGeneric<string> = [
      {name: this.translate(this.keyLocaleTypeOperationalMixed), value: localeType.OperationalMixed.toString() },
      {name: this.translate(this.keyLocaleTypeActing), value: localeType.Acting.toString() },
    ];

    public readonly salesTypes: NameValuesGeneric<string> = [
      {name: salesType.Retail.toString(), value: salesType.Retail.toString() },
      {name: salesType.RetailExceptBigFleet.toString(), value: salesType.RetailExceptBigFleet.toString() },
      {name: salesType.Total.toString(), value: salesType.Total.toString() },
    ];

    public mitsubishStoresLocation: MitsubishStoresLocationAnnualPerformance[] = [];

    public chosenReportType: OptionalNameValue = this.types[0];
    public chosenPrintType: OptionalNameValue = this.types[0];
    public chosenRegional: NameValues = [];
    public chosenArea: NameValues = [];
    public chosenGroups: NameValues = [];
    public chosenStores: NameValues = [];
    public chosenPeriod: PeriodFormValue = null;
    public chosenLocaleType: NameValueGeneric<string> = this.localeType[0];
    public chosenSalesType: NameValueGeneric<string> = this.salesTypes[0];

    public reportTypeEnum = reportTypeEnum;

    public url: string = '';
    public labelFilters: IKeyValues = [];

    @Getter(GET_PERIOD)
    public getPeriod: (key: ReportEnum) => Period;

    public get formValid(): boolean {
      return !!this.chosenPrintType
        && !!this.chosenPrintType.value
        && !!this.chosenLocaleType
        && !!this.chosenLocaleType.value
        && !!this.chosenSalesType
        && !!this.chosenSalesType.value;
    }

    public get limits(): Period {
      return this.getPeriod(ReportEnum.AnnualSalesPerformance);
    }

    public created(): void {
      FilterService.getMitsubishStoresLocationAnnualPerformance()
        .then(x => this.mitsubishStoresLocation = x);
    }

    public showReport(): void {
      const {chosenPeriod} = this;

      if (!chosenPeriod)
        return;

      const params = {
        Tipo: this.chosenPrintType,
        regional: this.chosenRegional,
        idLocale: this.chosenArea,
        group: this.chosenGroups,
        Dealer: this.chosenStores,
        typeArea: this.chosenLocaleType,
        tipoVenda: this.chosenSalesType,
        ...chosenPeriod.value
      };

      traceLogAccess.logAction(ContextEnum.Report, 'Performance de Vendas Anual - Filtro', JSON.stringify(params));
      this.url = '';

      if (this.chosenReportType!.value === reportTypeEnum.analytics) {
        this.url = `${CONFIG.URL.NEODASH_API}/api/neodash/getCsv/annualSalesPerformance`
        httpService.httpBlob.post(this.url, {
          monthInitial: chosenPeriod.value.dtMonthInit,
          yearInitial: chosenPeriod.value.dtYearInit,
          monthFinal: chosenPeriod.value.dtMonthFinal,
          yearFinal: chosenPeriod.value.dtYearFinal,
      }, {timeout: 0})
        .then((res: AxiosResponse) => {
          const blob = new Blob([res.data], {
            type: 'text/csv'
          });
          kendo.saveAs({
            dataURI: window.URL.createObjectURL(blob),
            fileName: res
              .headers['content-disposition']
              .substring(21, res.headers['content-disposition'].length)
          });
        })
        .catch((err: AxiosError) => {
          console.log(err.message);
        });
        return;
      }

      setTimeout(() => {
        this.url = getUrlReportViewer(ReportsReportViewerEnum.PerformanceSalesAnnual, params);
        this.updateFilters();
      }, 500);
    }

    public downloadZipPages() {
      const {chosenPrintType, chosenPeriod} = this;

      if (!chosenPeriod || !chosenPrintType)
        return;

      let reportName = `PVA_${chosenPrintType.name}`;
      if (this.chosenRegional.length)
        reportName += this.chosenRegional.length > 1 ? '_Regionais' : `_${this.chosenRegional[0].name}`;

      if (this.chosenArea.length)
        reportName += this.chosenArea.length > 1 ? '_Area de Atuacao' : `_${this.chosenArea[0].name}`;

      if (this.chosenGroups.length)
        reportName += this.chosenGroups.length > 1 ? '_Grupos' : `_${this.chosenGroups[0].name}`;

      if (this.chosenStores.length)
        reportName += this.chosenStores.length > 1 ? '_Lojas' : `_${this.chosenStores[0].name}`;

      const params = {
        idTargetType: chosenPrintType.value,
        idRegions: Array.from(this.chosenRegional, ({value}) => value),
        idActingArea: Array.from(this.chosenArea, ({value}) => value),
        idEconomicGroups: Array.from(this.chosenGroups, ({value}) => value),
        idDealers: Array.from(this.chosenStores, ({value}) => value),
        initialYear: chosenPeriod.value.dtYearInit,
        initialMonth: chosenPeriod.value.dtMonthInit,
        finalYear: chosenPeriod.value.dtYearFinal,
        finalMonth: chosenPeriod.value.dtMonthFinal,
        PrefixReportName: reportName,
        saleTypeName: this.chosenSalesType.value,
        LocaleTypeName: this.chosenLocaleType.value
      };

      traceLogAccess.logAction(ContextEnum.Report, 'Performance de Vendas Anual - Donwload', JSON.stringify(params));
      ServiceHelper.generateFile(`${CONFIG.URL.NEODASH_API}/api/neodash/getPdf/annualSalesPerformance`, `${reportName}.zip`, {
        method: 'post',
        parameters: params
      });
    }

    private updateFilters(): void {
      const {translate, chosenStores, chosenGroups, chosenArea, chosenLocaleType, chosenSalesType, chosenRegional, chosenPrintType, chosenPeriod, shouldShow} = this;

      if (!chosenPrintType || !chosenPeriod)
        return;

      const getText = (lst: NameValues): string =>
        !!lst.length ? lst.map(x => !!x && x.name).join(', ') : translate('Common.All');

      const labels: (labelFilter | IKeyValue)[] = [
        {text: this.keyLabelPrintType, value: chosenPrintType.name},
        {text: this.keyLabelRegional, value: getText(chosenRegional), type: printTypeEnum.regions},
        {text: this.keyLabelLocaleType, value: chosenLocaleType.name},
        {text: this.keyLabelArea, value: getText(chosenArea), type: printTypeEnum.areas},
        {text: this.keyLabelGroup, value: getText(chosenGroups), type: printTypeEnum.groups},
        {text: this.keyLabelDealers, value: getText(chosenStores), type: printTypeEnum.dealers},
        {text: this.keyLabelSalesType, value: chosenSalesType.value},
        {text: 'Common.Period', value: chosenPeriod.label}
      ];

      this.labelFilters = labels
        .filter(x => {
          const label = x as labelFilter;
          return !label.type || shouldShow(label.type);
        })
        .map(({text, value}) => ({
          text: translate(text),
          value
        }));
    }

    public get allRegional(): NameValues {
      return this.mitsubishStoresLocation
        .filter(x => x.localeType === this.chosenLocaleType.value)
        .distinctBy(x => x.idRegional)
        .map(x => ({
          name: x.nameRegional,
          value: x.idRegional,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    }

    public get areasByRegion(): NameValues {
      return this.mitsubishStoresLocation
        .filter(x => x.localeType === this.chosenLocaleType.value
          && this.chosenRegional.some(r => !!r && r.value === x.idRegional))
        .distinctBy(x => x.idArea)
        .map(x => ({
          name: x.nameArea,
          value: x.idArea,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    }

    public get actingAreas(): NameValues {
      const filter: StoresFilter = x =>
        this.chosenRegional.some(z => !!z && z.value === x.idRegional) || !this.chosenRegional.length;

      return this.mitsubishStoresLocation
        .filter(x => x.localeType === this.chosenLocaleType.value)
        .filter(filter)
        .distinctBy(x => x.idArea)
        .map(x => ({
          name: x.nameArea,
          value: x.idArea
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    }

    public get groups(): NameValues {
      const {chosenArea: chosenActingArea} = this;

      const getPredicate: FilterNameValue = lst => x => lst.some(z => !!z && z.value === x.idArea);
      const lstForFilters: NameValues = !!chosenActingArea.length ? chosenActingArea : this.actingAreas;

      return this.mitsubishStoresLocation
        .filter(x => x.localeType === this.chosenLocaleType.value)
        .filter(getPredicate(lstForFilters))
        .distinctBy(x => x.idGroup)
        .map(x => ({
          name: x.nameGroup,
          value: x.idGroup
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    }

    public get stores(): NameValues {
      const {chosenGroups, chosenArea: chosenActingArea} = this;

      const getPredicate: FilterMultipleNameValue = (lstGroups: NameValues, lstActingAreas: NameValues) => x =>
        lstGroups.some(z => !!z && z.value === x.idGroup && lstActingAreas.some(u => u.value === x.idArea));

      const lstGroupsForFilter: NameValues = !!chosenGroups.length ? chosenGroups : this.groups;
      const lstActingAreasForFilter: NameValues = !!chosenActingArea.length ? chosenActingArea : this.actingAreas;

      return this.mitsubishStoresLocation
        .filter(x => x.localeType === this.chosenLocaleType.value)
        .filter(getPredicate(lstGroupsForFilter, lstActingAreasForFilter))
        .map(({name, id}) => ({
          value: id,
          name
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    }

    public shouldShow(type: printTypeEnum): boolean {
      return !!this.chosenPrintType && this.chosenPrintType.value >= type;
    }

    public changeLocaleType() {
      this.chosenRegional = [];
      this.chosenArea = [];
      this.chosenGroups = [];
      this.chosenStores = [];
    }

    public changePrintType() {
      this.chosenRegional = [];
      this.chosenArea = [];
      this.chosenGroups = [];
      this.chosenStores = [];
    }

    public changeReportType() {
      
    }
  }
